/**
 * Detects the active traffic source based on URL parameters
 * Checks for utm_source, src
 */

export function detectTrafficSource(searchParams: URLSearchParams | null): 'google' | 'bing' | null {
  if (!searchParams) {
    return null;
  }

  const source = searchParams.get('utm_source') || searchParams.get('src');

  // Check for Google indicators
  if (source?.toLowerCase().includes('google')) {
    return 'google';
  }

  // Check for Bing indicators
  if (source?.toLowerCase().includes('bing')) {
    return 'bing';
  }

  return null;
}

export function getNdrHomeUrl(source: 'google' | 'bing'): string {
  return source === 'bing' ? 'https://dc.fortune.com/reviews-2/' : 'https://dc.fortune.com/reviews-1/';
}

export const trackGtmEvent = (url: string) => {
  if (typeof window !== 'undefined' && typeof window.gtag_report_conversion === 'function') {
    window.gtag_report_conversion(url);
  }
};

export function isNdrLink(url: string): boolean {
  return url.includes('nationaldebtrelief.com');
}

export const getQueryParamsString = (
  searchParams: URLSearchParams | null,
  source: 'google' | 'bing' | undefined,
): string => {
  const allQueryParamsString =
    searchParams?.toString() || (source === 'google' ? 'src=fortune.google.organic' : 'src=fortune.bing.organic');
  return allQueryParamsString;
};
